<template>
  <div class="app-container">
    <div ref="searchForm">
      <el-card class="mb5">
        <el-form
          ref="form" :model="queryForm"
          label-position="top" size="small"
          class="searchContainer"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--账单日期 -->
                <el-form-item :label="$t('receivablePayable.BillingDate')">
                  <el-date-picker
                    v-model="queryForm.params.payableTimes"
                    style="width: 100%"
                    range-separator="-"
                    type="daterange"
                    :start-placeholder="$t('operationCenter.startDate')"
                    :end-placeholder="$t('operationCenter.endDate')"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--对账状态-->
                <el-form-item :label="$t('receivablePayable.BillingStatus')">
                  <el-select
                    v-model="queryForm.params.auditStatus"
                    filterable
                    multiple
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in BILL_STATUS"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--应收主体-->
                <el-form-item :label="$t('basicData.businessPrincipal')">
                  <el-select
                    v-model="queryForm.params.providerId"
                    filterable
                    :placeholder="$t('operationCenter.Only10AreDisplayed')"
                    :remote-method="getProviderPage"
                    remote
                    clearable
                    style="width: 100%;"
                    @focus="getProviderPage('')"
                  >
                    <el-option
                      v-for="item in providerList"
                      :key="item.id"
                      :label="item.providerName + '（' + item.code + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--客户-->
                <el-form-item :label="$t('GlobalSetObj.client')">
                  <CustomerSelectCmp style="width: 100%" :is-all="false" @change=" val => queryForm.params.customerId = val" />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--生成时间-->
                <el-form-item :label="$t('receivablePayable.BuildTime')">
                  <el-date-picker
                    v-model="queryForm.params.time"
                    type="datetimerange"
                    style="width: 100%"
                    :start-placeholder="$t('operationCenter.startDate')"
                    :end-placeholder="$t('operationCenter.endDate')"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--生成人-->
                <el-form-item :label="$t('receivablePayable.BuildThePerson')">
                  <QueryUserV2Cmp :val="queryForm.params.handlerId" style="width: 100%" @change=" val => queryForm.params.handlerId = val" />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--账单批次号-->
                <el-form-item :label="$t('receivablePayable.BillingBatchNumber')">
                  <InputTextareaCmp
                    ref="inputTextareaRef"
                    :val="queryForm.params.billBatchNumber"
                    :max-length="200"
                    @input="(_, val) => queryForm.params.billBatchNumber = val"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <!--对账单类型-->
                <el-form-item :label="$t('receivablePayable.statementType')">
                  <el-select
                    v-model="queryForm.params.statementType"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    size="small"
                    filterable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in EXPRESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="searchResources()"
        >
          {{ $t('operationCenter.Procurar') }}
        </el-button>
        <!--重置-->
        <el-button
          icon="el-icon-refresh"
          size="small"
          @click="onReset"
        >{{ $t('basicData.reset') }}
        </el-button>
      </el-card>
    </div>

    <el-card>
      <div style="margin-bottom: 10px;" class="row">
        <div class="flex">
          <!--导入生成收款-->
          <el-button
            v-permit:remove="'btn:receivableManagementSite:toExamine:import'"
            size="small"
            type="primary"
            @click="operationBtn(1)"
          >{{ $t('receivablePayable.importGenerateReceipt') }}</el-button>
          <!--审核-->
          <el-button
            v-permit:remove="'btn:receivableManagementSite:toExamine:approved'"
            :disabled="!isExamine"
            size="small"
            type="primary"
            @click="operationBtn(2)"
          >{{ $t('receivablePayable.examine') }}</el-button>
          <!--自定义栏目-->
          <CustomStatusBar
            :columns-data="TABLE_HEADER"
            :params="searchParams"
            :save-params="customParams"
            @updateColumns="updateColumns"
          />
        </div>
        <div>
          <el-button
            v-permit:remove="'btn:receivableManagementSite:toExamine:export'"
            icon="el-icon-download"
            size="small"
            @click="onExport"
          >{{ $t('basicData.账单导出') }}</el-button>
          <el-button
            v-permit:remove="'btn:receivableManagementSite:toExamine:exportDetail'"
            icon="el-icon-download"
            size="small"
            @click="onExportDetail"
          >{{ $t('basicData.账单明细导出') }}</el-button>
        </div>
      </div>

      <div class="pending">
        <el-table
          ref="elTable"
          :key="tableKey"
          :data="tableData"
          border
          class="table-height"
          :height="tableHeightRow.height"
          @header-dragend="headerWidthChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
            <template v-slot="scope">
              <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in currentColumns"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :align="item.align"
            :min-width="item.width"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <!--账单批次号-->
              <div v-if="item.prop === 'billBatchNumber'" class="batchNumber" @click="showBillBatchNumber(scope.row)">
                {{ scope.row.billBatchNumber }}
              </div>
              <div v-else-if="item.prop === 'statementType'">
                {{ EXPRESS_TYPE[scope.row.statementType] ? EXPRESS_TYPE[scope.row.statementType].label : '' }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column
            :label="$t('basicData.operate')"
            align="center"
            width="140"
            fixed="right"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <!-- 已对账、撤回中、审核中不可操作 -->
              <div
                v-if="$store.state.user.id === scope.row.createUser && [0,4].includes(scope.row.auditStatus)"
                v-permit:remove="'btn:receivableManagementSite:toExamine:recall'"
              >
                <el-button
                  type="danger"
                  size="mini"
                  @click="recall(scope.row)"
                >{{ $t('receivablePayable.withdraw') }}</el-button><!--撤回-->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页工具 -->
        <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="queryForm.pageNumber"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size.sync="queryForm.pageSize"
            :total="total"
            background
            style="margin: 10px 0"
            @current-change="getExaminePage"
            @size-change="getExaminePage"
          />
        </div>
      </div>
    </el-card>

    <!--  对账批次详情  -->
    <el-drawer
      :title="$t('receivablePayable.ReconcileBatchDetails') + '-' + batchNumber"
      :append-to-body="true"
      :visible.sync="showDetail"
      direction="ltr"
      custom-class="drawerClass"
      :label="$t('receivablePayable.ReconcileBatchDetails')"
      size="80%"
    >
      <batch-number-detail
        :key="batchNumberKey"
        :batch-number="batchNumber"
        :bill-batch-data="billBatchData"
        @closeDetail="closeDetail"
      />
    </el-drawer>

    <!-- 审核-->
    <el-dialog
      :title="$t('receivablePayable.examine')"
      :visible.sync="showExamine"
      width="600px"
    >
      <ExamineDialog
        :key="ExamineKey"
        :params="examineParams"
        @submit="examineSubmit"
        @close="examineCancel"
      />
    </el-dialog>

    <!-- 导入生成收款-->
    <el-dialog
      :title="$t('receivablePayable.importGenerateReceipt')"
      :visible.sync="showReceipt"
      width="600px"
    >
      <ImportReceipt
        :key="ReceiptKey"
        @close="showReceipt = false"
      />
    </el-dialog>
  </div>
</template>

<script>
// import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiSiteBillAudit, apiSiteBillGetPage, apiSiteWithdraw, apiSiteWithdrawalTips } from '@/api/finance/receivables';
import { apiProviderPage, apiSiteBillExport, apiSiteBillExportDetailed } from '@/api/finance/basicData';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { BILL_STATUS, exportDetailCheck, TABLE_HEADER } from './utils';
import { EXPRESS_TYPE } from '../aRGenerationNew/utils';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { cloneDeep } from 'lodash-es';

const PARAM = {
  billBatchNumber: '', // 对账单批次号
  auditStatus: [0, 4], // 账单状态
  providerId: '', // 供应商应收主体
  customerId: '', // 客户
  handlerId: '', // 生成人id
  time: '', // 生成时间
  payableTimes: [], // 账单日期
  statementType: '' // 对账单类型
};

export default {
  name: 'ToExamine',
  components: {
    batchNumberDetail: () => import('./cmp/batchNumberDetail.vue'),
    CustomerSelectCmp: () => import('@/components/CustomerSelectCmp/CustomerSelectCmp.vue'),
    QueryUserV2Cmp: () => import('@/views/finance/cmp/Query/QueryUserV2Cmp.vue'),
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    ExamineDialog: () => import('./cmp/examineDialog.vue'),
    ImportReceipt: () => import('./cmp/importReceipt.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      TABLE_HEADER,
      EXPRESS_TYPE,
      BILL_STATUS,
      queryForm: {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...PARAM
        }
      },
      tableData: [],
      total: 0,
      tableKey: new Date().getTime(),
      showDetail: false,
      batchNumber: '', // 对账单批次号
      batchNumberKey: new Date().getTime(),
      billBatchData: {},
      providerList: [],
      selectData: [],
      currentColumns: [],
      searchParams: {
        type: 0,
        menuEnum: 'companyToSiteBillReview'
      },
      customParams: {
        templateField: '',
        templateName: '应收账单审核',
        userId: '',
        ...this.searchParams
      },
      showExamine: false,
      examineParams: {},
      ExamineKey: new Date().getTime(),
      showReceipt: false,
      ReceiptKey: new Date().getTime()
    };
  },
  computed: {
    // 审核状态
    isExamine() {
      console.log(this.selectData.every(item => (item.auditStatus === 0 || item.auditStatus === 4)));
      if (this.selectData.length) {
        return this.selectData.every(item => item.auditStatus === 0 || item.auditStatus === 4);
      }
      return false;
    }
  },
  created() {
    // this.createUser = getUserIdAndNameObj();
    this.getExaminePage();
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
      // console.log(list, '列表呈现的columns');
    },
    // 查询当前批次未对账账单
    async queryTotal(number) {
      const res = await apiSiteWithdrawalTips({
        billBatchNumberList: number
      });
      return res.data;
    },
    // 撤回
    async recall(row) {
      const res = await this.queryTotal([row.billBatchNumber]);
      const { totalCount, unPaidCount } = res;
      const h = this.$createElement;
      this
        .$msgbox({
          // '提示'
          title: this.$t('basicData.tips'),
          message: h('p', null, [
            h('span', this.$t('receivablePayable.total')),
            h('span', this.$t('receivablePayable.totalCount')),
            h('span', { style: 'color: red' }, totalCount),
            h('span', this.$t('receivablePayable.unit')),
            h('span', this.$t('receivablePayable.data') + ', '),
            h('span', this.$t('receivablePayable.currentWithdrawal')),
            h('span', { style: 'color: red' }, unPaidCount),
            h('span', this.$t('receivablePayable.unit')),
            h('span', this.$t('receivablePayable.unreconciledData')),
            h('div', { style: 'color: red' }, this.$t('receivablePayable.AreYouSureYouWantToWithdraw'))
          ]),
          showCancelButton: true,
          confirmButtonText: this.$t('basicData.determine'), // '确定',
          cancelButtonText: this.$t('basicData.Cancel'), // '取消'
          type: 'warning'
        }).then(() => {
          apiSiteWithdraw(row.id).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));
              this.getExaminePage();
            }
          });
        });
    },
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },
    // 关闭详情
    closeDetail() {
      this.showDetail = false;
    },
    // 获取业务主体
    getProviderPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          providerName: name
        }
      };
      apiProviderPage(param, false).then(res => {
        if (res.code === 200) {
          this.providerList = res.data.records;
        }
      });
    },

    // 请求数据处理
    getQueryData() {
      const query = cloneDeep(this.queryForm);

      query.params.billBatchNumbers = [];

      const { time } = query.params;

      // 生成时间处理
      if (Array.isArray(time) && time.length === 2) {
        query.params.startTime = time[0];
        query.params.endTime = time[1];
      }
      query.params.time = undefined;

      // 账单批次号
      if (query.params.billBatchNumber.length >= 1) {
        query.params.billBatchNumbers = this.$refs.inputTextareaRef.getValue();
      }
      // 替换字段
      query.params.billBatchNumber = undefined;

      return query;
    },

    // 获取列表数据
    getExaminePage() {
      const row = this.getQueryData();
      apiSiteBillGetPage(row).then(res => {
        if (res.code === 200) {
          // this.tableData = res.data.records;
          this.tableData = (res.data.records || []).map(item => {
            return Object.freeze(item);
          });
          this.total = res.data.total;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 获取对账批次详情
    showBillBatchNumber(data) {
      this.batchNumberKey = new Date().getTime();
      this.batchNumber = data.billBatchNumber;
      this.billBatchData = data;
      this.showDetail = true;
    },
    // 搜索
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getExaminePage();
    },
    // 重置
    onReset() {
      this.queryForm.params = {
        ...PARAM
      };

      this.searchResources();
    },
    /**
     * 按钮操作
     * @param type 1 导入收款 2 审核
     * @returns {boolean}
     */
    async operationBtn(type) {
      if (type === 2) {
        if (!this.selectData.length) {
          this.$message.warning(this.$t('receivablePayable.SelectAtLeastOnePieceOfData')); // 最少要选择一条数据
          return;
        }
        const list = this.selectData.map(item => {
          return item.billBatchNumber;
        });
        this.examineParams = await this.queryTotal(list);
        this.showExamine = true;
        this.ExamineKey = new Date().getTime();
      } else {
        this.showReceipt = true;
        this.ReceiptKey = new Date().getTime();
      }
    },
    // 审核保存
    examineSubmit(obj) {
      const ids = [];
      this.selectData.map(item => {
        ids.push(item.billBatchNumber);
      });
      const param = {
        billBatchNumbers: ids,
        operationType: obj.examine,
        auditReason: obj.remark
      };
      apiSiteBillAudit(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          this.getExaminePage();
          this.showExamine = false;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    examineCancel() {
      this.showExamine = false;
    },
    // 账单导出
    onExport() {
      const { params } = this.getQueryData();
      params.ids = this.selectData.map(item => {
        return item.id;
      });

      apiSiteBillExport(params).then(() => {
        goResourceTaskList();
      }).catch(err => {
        console.error(err);
      });
    },

    // 账单明细导出
    onExportDetail() {
      const { params } = this.getQueryData();
      // 校验
      if (!exportDetailCheck(params)) {
        return;
      }

      params.ids = this.selectData.map(item => {
        return item.id;
      });

      apiSiteBillExportDetailed(params).then(() => {
        goResourceTaskList();
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
::v-deep .drawerClass .el-drawer__body {
  overflow-y: scroll;
}
.batchNumber {
  color: #007efd;
  cursor: pointer;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style>
.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  border-color: #aaa;
}
.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #aaa;
}
.pending .el-table tr.background {
  background-color: #FF0000!important;
  color: #FFF;
}
.pending .el-table tr.background:hover td {
  background-color: #FF0000!important;
  color: #FFF;
}

</style>
